import { setTerm } from './helpers';

export const setContact = setTerm('contact');
